import Form from '../stores/Form';

export default (fn) =>
    (...args) => {
        const { fields, options } = typeof fn === 'function' ? fn(...args) : fn;
        return new Form(fields, options);
    };
